import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  private baseUrl = `${this.appConfigService.CoreAPIUrl}/report`;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService) {
  }

  getReportSummaryByStates(year, month) {
    return this.http.get<any>(`${this.baseUrl}/state/summary?year=${year}&month=${month}`);
  }

  getDailyYieldSummary() {
    return this.http.get<any>(`${this.baseUrl}/yield/daily/summary`);
  }

  getTotalYieldSummary() {
    return this.http.get<any>(`${this.baseUrl}/yield/total/summary`);
  }

  getLssPlantInfo() {
    return this.http.get<any>(`${this.baseUrl}/plant/lss`);
  }

  getYieldGuaranteePlants() {
    return this.http.get<any>(`${this.baseUrl}/plant/yieldGuarantee`);
  }

  getPrGuaranteePlants() {
    return this.http.get<any>(`${this.baseUrl}/plant/prGuarantee`);
  }
}
